import Axios from 'axios';
import { store } from '@bmp-vue/core/plugins/store';
import { FormatURLParams } from '@/utils/axiosUtils';
import { gerarIdempotencyKey } from '@/utils/idemPotencyKey';
import util from '@bmp-vue/core/api/util';
import ui from '@bmp-vue/core/api/ui';

const axios = {
  DownloadFile: function (controller, params) {
    const token = localStorage.getItem('user') !== null ? JSON.parse(localStorage.getItem('user')).token : null;
    const headers = (token) ? { Authorization: `Bearer ${token}` } : {};

    params = params ? FormatURLParams(params) : {};
    store.commit('addRequest');
    return Axios.get(controller, {
      responseType: 'arraybuffer',
      params,
      headers: headers
    }).then(HandleResponseBase, HandleErrorBase);
  },
  GetParams: function (controller, params, config = {}) {
    const token = localStorage.getItem('user') !== null ? JSON.parse(localStorage.getItem('user')).token : null;
    const headers = (token) ? { Authorization: `Bearer ${token}` } : {};

    params = params ? FormatURLParams(params) : {};
    store.commit('addRequest');
    return Axios.get(controller, {
      params,
      headers: headers,
      ...config
    }).then(HandleResponseBase, HandleErrorBase);
  },

  Post: function (controller, dto, headers, token) {
    const idempotencyKey = gerarIdempotencyKey();
    if (!token)
      token = localStorage.getItem('user') !== null ? JSON.parse(localStorage.getItem('user')).token : null;

    store.commit('addRequest');
    if (headers) {
      headers.idempotencyKey = idempotencyKey;

      return Axios.post(controller, dto, {headers}).then(
        HandleResponseBase,
        HandleErrorBase
      );
    } else {
      return Axios.post(controller, dto, {
        headers: {
          Authorization: `Bearer ${token}`,
          idempotencyKey
        }
      }).then(HandleResponseBase, HandleErrorBase);
    }
  },

  PostForm: function (controller, dto) {
    const idempotencyKey = gerarIdempotencyKey();
    const { token } = JSON.parse(localStorage.getItem('user'));
    store.commit('addRequest');
    return Axios.post(controller, dto, {
      headers: {
        'Content-Type': `multipart/form-data; boundary=${dto._boundary}`,
        Authorization: `Bearer ${token}`,
        idempotencyKey
      }
    }).then(HandleResponseBase, HandleErrorBase);
  },

  Put: function (controller, id, dto) {
    const idempotencyKey = gerarIdempotencyKey();
    const token = localStorage.getItem('user') !== null ? JSON.parse(localStorage.getItem('user')).token : null;
    const headers = (token) ? { Authorization: `Bearer ${token}`, idempotencyKey } : {idempotencyKey};
    if (!dto)
      dto = {};

    store.commit('addRequest');
    return Axios.put(controller + '/' + id, dto, {
      headers: headers
    }).then(HandleResponseBase, HandleErrorBase);
  },

  Delete: (controller, id) => {
    const idempotencyKey = gerarIdempotencyKey();
    const { token } = JSON.parse(localStorage.getItem('user'));
    store.commit('addRequest');
    return Axios.delete(controller + '/' + id, {
      headers: {
        Authorization: `Bearer ${token}`,
        idempotencyKey
      }
    }).then(HandleResponseBase, HandleErrorBase);
  }
};

const api = {
  ...util,
  Axios: axios,
  controller: 'UTIL',
  ResponseFunctions: {
    HandleResponseBase,
    HandleErrorBase
  }
};

function HandleResponseBase(response) {
  ui.HideLoading();
  store.commit('removeRequest');

  if (
    (response.count && response.data) ||
    (response.count === 0 && response.data === [])
  ) {
    return response;
  }
  if (response.data.meta) {
    return response.data;
  }
  if (response.data.data || response.data.data === []) {
    if (response.data.count || response.data.count === 0) {
      return response.data;
    }
    return response.data.data;
  }

  return response.data;
}

function HandleErrorBase(error) {
  ui.HideLoading();
  store.commit('removeRequest');

  if (Axios.isCancel && Axios.isCancel(error)) {
    return ui.ShowError('Erro', 'A exportação demorou mais que o esperado. Tente novamente mais tarde.');
  }

  if (error) {
    const response = error.response;
    if (response && response.data) {
      if ('token' in response.data) {
        return response;
      } else if (response.data.messages) {
        response.data.messages.map(message =>
          ui.ShowError(
            message.context,
            `${message.code} - ${message.description}`
          )
        );
        return response;
      }
    }
  }

  ui.ShowError('Erro', 'Ocorreu um erro inesperado');
  return { data: { hasError: true } };
}

export default api;
